import { motion } from "framer-motion";
import { useDownload } from "@/hooks/useDownload";
import { AppDownloadButton } from "./AppDownloadButton";
import { OpportunityCard } from "./OpportunityCard";
import { SectionHeading } from "./SectionHeading";
import { EASE } from "./Motion";

const CATEGORIES = [
  ["Playlists", "Editorial & curator windows"],
  ["Radio", "Rotation & specialist shows"],
  ["Press", "Features, reviews, interviews"],
  ["TV", "Broadcast & performance slots"],
  ["Sync", "Film, series, ads & games"],
  ["Brands", "Partnerships & campaigns"],
  ["Festivals", "Stages & showcases"],
  ["Distribution", "Release & delivery partners"],
  ["Marketing", "Promotion services"],
  ["Artist Development", "Programs & mentorship"],
];

export const Opportunities = () => {
  const download = useDownload();
  return (
    <section id="opportunities" data-testid="opportunities-section" className="border-t border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 py-section-sm sm:px-8 lg:px-12 lg:py-section">
        <div className="grid gap-10 lg:grid-cols-12">
          <SectionHeading
            className="lg:col-span-9"
            eyebrow="Opportunities / 06"
            lines={["Your next opportunity", "could be closer", "than you think."]}
            label="Your next opportunity could be closer than you think."
          />
          <div className="self-end lg:col-span-3">
            <p className="text-base leading-relaxed text-pa-muted">Briefs across ten categories, filtered by market, genre and deadline — inside the app.</p>
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: EASE }}
          className="mt-16 grid grid-cols-2 border-l border-t border-white/10 md:grid-cols-3 lg:mt-24 lg:grid-cols-5"
        >
          {CATEGORIES.map(([name, hint], i) => (
            <OpportunityCard key={name} index={i + 1} name={name} hint={hint} onClick={() => download({ source: `opportunity-${name.toLowerCase()}` })} />
          ))}
        </motion.div>
        <AppDownloadButton label="Explore opportunities" source="opportunities" testId="opportunities-cta" className="mt-12" />
      </div>
    </section>
  );
};
